<template>
    <div class="pending-final">
        <div class="final-card">
            <div class="final-icon">✓</div>
            <span class="eyebrow">Заявка принята</span>
            <h2>Данные получены</h2>
            <p>
                Скоро мы свяжемся с вами, проверим подключение CRM и подскажем следующий шаг.
            </p>
            <div class="final-note">
                Если нужно что-то уточнить, напишите в техподдержку Data Heroes:
                <a
                    href="https://t.me/dataheroes_bot"
                    target="_blank"
                    rel="noopener noreferrer"
                ><strong>Telegram</strong></a>
                или
                <a
                    href="https://max.ru/id7707452371_bot"
                    target="_blank"
                    rel="noopener noreferrer"
                ><strong>MAX</strong></a>
            </div>
        </div>
    </div>
</template>

<script>
import { inject, onBeforeUnmount, onMounted } from 'vue'

/**
 * Финальный экран «Данные получены» для:
 * - AuthorizationPending (pending CRM после ввода данных)
 * - Settings без настроек (yClients / ПрофСалон / Altegio) в онбординге
 */
export default {
    name: 'CrmConnectionPendingFinal',
    props: {
        /** Скрыть кнопки футера онбординга */
        lockWizardNav: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const wizardNav = inject('onboardingWizardNav', null)

        const syncWizardNav = () => {
            if (!props.lockWizardNav || !wizardNav) return
            wizardNav.set({
                canBack: false,
                canNext: false,
                showNext: false,
                nextLoading: false,
                onBack: null,
                onNext: null,
            })
        }

        onMounted(() => {
            syncWizardNav()
        })

        onBeforeUnmount(() => {
            if (props.lockWizardNav) {
                wizardNav?.reset?.()
            }
        })

        return {}
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.pending-final
    width: 100%
    display: flex
    align-items: center
    justify-content: center

.final-card
    width: 100%
    max-width: 720px
    border-radius: 28px
    background: #fff
    border: 1px solid $border-new
    box-shadow: 0 16px 42px rgba(26, 26, 46, 0.08)
    padding: 40px
    display: grid
    justify-items: center
    text-align: center
    gap: 14px

    h2
        font-size: 38px
        line-height: 1.02
        letter-spacing: -0.06em
        margin: 0
        font-weight: 800
        color: $dark-new

    p
        margin: 0
        color: $muted-new
        font-size: 15px
        line-height: 1.6
        max-width: 560px

.final-icon
    width: 64px
    height: 64px
    border-radius: 20px
    background: #E9FFF4
    color: #12945D
    display: grid
    place-items: center
    font-size: 30px
    font-weight: 900

.eyebrow
    display: inline-flex
    align-items: center
    margin: 0
    color: $main-new
    font-size: 11px
    font-weight: 900
    text-transform: uppercase
    letter-spacing: 0.14em

.final-note
    margin-top: 8px
    border: 1px solid $border-new
    border-radius: 16px
    background: #F8FAFF
    padding: 14px 18px
    color: #596174
    font-size: 13px
    line-height: 1.5
    max-width: 580px

    a
        color: #2F8CFF
        font-weight: 900
        text-decoration: underline
        text-decoration-thickness: 1px
        text-underline-offset: 3px
        &:hover
            color: $main-new

@media (max-width: 700px)
    .final-card
        padding: 28px 20px
        h2
            font-size: 28px
</style>
